import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ContenutoGenericoService } from "../service/contenuto-generico.service";
import { ContenutoGenerico } from "../model/contenuto-generico";
import { AllegatoService } from "../service/allegato.service";
import { Allegato } from "../model/allegato";
import { Search } from "../common/search";
import { DOCS_PATH, DOCS_REPLACE } from "../constants/constants";
import { NewsService } from "../service/news.service";
import { News } from "../model/news";
import { BlogService } from "../service/blog.service";
import { Blog } from "../model/blog";
import { MultilinguaService } from "../service/multilingua.service";
import { MenuService } from "../service/menu.service";
import { Multilingua } from "../model/multilingua";
import { Location } from "@angular/common";
import { ServizioService } from "../service/servizio.service";
import { Servizio } from "../model/servizio";
import { DocumentoService } from "../service/documento.service";
import { Documento } from "../model/documento";
import { Observable } from "rxjs";
import "rxjs-compat/add/operator/mergeMap";
import { map, mergeAll, mergeMap } from "rxjs/operators";
import { SeoService } from "../service/seo.service";

@Component({
  selector: "app-homepage",
  templateUrl: "./homepage.component.html",
})
export class HomepageComponent implements OnInit {
  public pageName: string = null;
  public element: ContenutoGenerico;
  public allegato: Allegato;
  public sottoGruppi: Array<ContenutoGenerico>;
  public loading = true;
  public path_immagine: string;
  public blogList: Array<Blog>;
  public newsList: Array<News>;
  public servizi: Array<Servizio>;
  public documentiList: Array<Documento>;
  public lingua: string;
  public random_image: string;

  slideConfig = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  };

  constructor(
    private contenutoService: ContenutoGenericoService,
    private allegatoService: AllegatoService,
    private documentoService: DocumentoService,
    private serviziService: ServizioService,
    private multilingueService: MultilinguaService,
    private newsService: NewsService,
    private blogService: BlogService,
    private menuService: MenuService,
    private location: Location,
    private seoService: SeoService,
    private router: Router,
    public route: ActivatedRoute
  ) {
    var random_images = ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg", "6.jpg"];

    this.random_image =
      random_images[Math.floor(Math.random() * random_images.length)];
  }

  ngOnInit() {
    this.route.url.subscribe(() => {
      const url = this.location.path().split("/");
      this.pageName = url.pop();
      // console.log('siamo in: ' + this.pageName);

      this.contenutoService.find(this.pageName).subscribe((homepage) => {
        if (homepage === null) {
          this.router.navigate(["/homepage"]);
        }
        this.element = homepage;
        this.lingua = this.element.lang;
        this.allegatoService.find(homepage.immagine).subscribe((allegato) => {
          if (allegato) {
            this.allegato = allegato;
            this.path_immagine = DOCS_REPLACE(allegato.uuid);
            this.seoService.setImage(this.path_immagine);
          }
        });
        this.newsList = new Array<News>();
        this.getNews();
        this.getBlog();
        this.getOtherLangs();
        this.getDocuments();
        this.loadServizi();
      });
    });
  }

  getDocuments() {
    this.documentoService.search = new Search<Documento>(Documento);
    this.documentoService.search._sort = "data_pubblicazione DESC";
    this.documentoService.search._.lang = this.lingua;
    if (this.lingua === "IT") {
      this.documentoService.search._.tipologia = "comunicati-stampa";
    } else {
      this.documentoService.search._.tipologia = "press-releases";
    }
    this.documentoService.search._start = 0;
    this.documentoService.search._limit = 4;
    this.documentoService.getList().subscribe((documents) => {
      this.documentiList = documents;
      this.loading = false;
    });
  }

  loadServizi() {
    this.serviziService.search = new Search<Servizio>(Servizio);
    this.serviziService.search._sort = "ordine ASC";
    this.serviziService.search._.lang = this.lingua;
    this.serviziService.getAllList().subscribe((servizi) => {
      this.servizi = servizi;
      for (const servizio of this.servizi) {
        this.allegatoService
          .find(servizio.immagine_lancio)
          .subscribe((allegato) => {
            if (allegato) {
              servizio.path_immagine = DOCS_REPLACE(allegato.uuid);
            }
          });
        this.allegatoService.find(servizio.logo).subscribe((allegato) => {
          if (allegato) {
            servizio.path_logo = DOCS_REPLACE(allegato.uuid);
          }
        });
      }
    });
  }

  getOtherLangs() {
    this.multilingueService.search = new Search<Multilingua>(Multilingua);
    if (this.lingua === "IT") {
      this.multilingueService.search._.it = this.element.uuid;
    } else if (this.lingua === "EN") {
      this.multilingueService.search._.eng = this.element.uuid;
    } else if (this.lingua === "PT") {
      this.multilingueService.search._.pt = this.element.uuid;
    }
    this.multilingueService.getList().subscribe((link) => {
      // console.log('link trovato: ' + link);
      const lingue = [];
      if (link.length > 0) {
        if (this.lingua === "EN" && link[0].it) {
          lingue.push("IT");
        }
        if (this.lingua === "IT" && link[0].eng) {
          lingue.push("EN");
        }
      }
      this.menuService.add(lingue);
    });
  }

  getDetailPage(): string {
    if (this.lingua === "IT") {
      return "news-detail";
    } else {
      return "news-detail-en";
    }
  }

  getDetailService(): string {
    if (this.lingua === "IT") {
      return "servizi";
    } else if (this.lingua === "EN") {
      return "services";
    } else {
      return "servios";
    }
  }

  getDetailPageBlog(): string {
    if (this.lingua === "IT") {
      return "blog-detail";
    } else {
      return "blog-detail-en";
    }
  }

  getNews() {
    this.newsService.search = new Search<News>(News);
    this.newsService.search._sort = "data_pubblicazione DESC";
    this.newsService.search._.lang = this.lingua;
    this.newsService.search._limit = 3;
    this.newsService.getList().subscribe((res) => {
      this.newsList = res;
      for (const newws of this.newsList) {
        if (newws.immagine_lancio) {
          newws.allegato = this.single(newws);
        }
      }
    });
  }

  getBlog() {
    this.blogService.search = new Search<Blog>(Blog);
    this.blogService.search._sort = "data_pubblicazione DESC";
    this.blogService.search._.lang = this.lingua;
    this.blogService.search._limit = 3;
    this.blogService.search._lt.data_pubblicazione = new Date();
    this.blogService.getList().subscribe((res) => {
      this.blogList = res;
      for (const blogg of this.blogList) {
        if (blogg.immagine_lancio) {
          blogg.allegato = this.single(blogg);
        }
      }
    });
  }

  getImage(imagepath: string) {
    return DOCS_REPLACE(imagepath);
  }

  single(neww: News | Blog): Observable<Allegato> {
    return this.allegatoService.find(neww.immagine_lancio);
  }
}
